import React, { useEffect, useState } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import NoteCard from '../../components/Cards/NoteCard';
import { MdAdd } from 'react-icons/md'
import AddEditNotes from '../AddEditNotes/AddEditNotes';
import Modal from 'react-modal';
import { useNavigate } from 'react-router-dom'
import axiosInstance from '../../Utils/axiosInstance';
import Toast from '../../components/Toast/Toast';
import EmptyCard from '../../components/Cards/EmptyCard';
import AddItemsSvg from '../../assets/additem.svg';
import NoData from '../../assets/nodata.svg';
import FullCard from '../../components/FullCard/FullCard';


const Home = () => {

    const [OpenAddEditModal, setOpenAddEditModal] = useState({
        isShown: false,
        type: 'add',
        data: null
    })

    const [showToast, setShowToast] = useState({
        isShown: false,
        type: "add",
        message: ""
    })
    const [allNotes, setallNotes] = useState([]);
    const [userInfo, setUserInfo] = useState(null);
    const [isSearch, setIsSearch] = useState(false);
    const [selectedNote, setSelectedNote] = useState(null);
    const navigate = useNavigate();

    const showHandleToast = (message, type) => {
        setShowToast({
            isShown: true,
            type,
            message
        })
    }
    const handleToastClose = () => {
        setShowToast({
            isShown: false,
            message: ""
        })
    }

    const handleEdit = (noteDetails) => {
        setOpenAddEditModal({
            isShown: true,
            type: 'edit',
            data: noteDetails
        })
    }
    const getUserInfo = async () => {
        try {
            const response = await axiosInstance.get("/get-user");
            if (response.data && response.data.user) {
                setUserInfo(response.data.user)
            }
        } catch (error) {

            if (error.response.status == 401) {
                localStorage.clear();
                navigate("/login")
            }
        }
    }
    //Get All Notes
    const getAllNotes = async () => {
        try {
            const response = await axiosInstance.get('get-all-note');
            if (response.data && response.data.notes) {
                setallNotes(response.data.notes)
            }
        } catch (error) {
            console.log("An Unexpected Error Accured! ")
        }
    }
    //Set All Notes
    const DeleteNote = async (data) => {
        const noteId = data._id
        try {
            const res = await axiosInstance.delete('/delete-note/' + noteId)

            if (res.data && !res.data.error) {
                showHandleToast("Note Deleted Successfully", "delete")
                getAllNotes();
            }
        } catch (error) {
            if (
                error.response &&
                error.response.data &&
                error.response.data.message
            ) {
                console.log("Something Went Wrong")
            }
        }
    }

    //Seach a Note
    const onSearchNote = async (query) => {
        try {
            const response = await axiosInstance.get('/search-notes', {
                params: { query }
            })
            if (response.data && response.data.notes) {
                setIsSearch(true);
                setallNotes(response.data.notes);
            }
        } catch (error) {
            console.log(error)
        }
    }

    // Pin a Note
    const updatePinedNote = async (noteData) => {
        const noteId = noteData._id;

        try {
            const response = await axiosInstance.put('/update-pinned-note/' + noteId, {
                isPinned: !noteData.isPinned
            })
            if (response.data && response.data.note) {
                if (response.data.note.isPinned == true) {
                    showHandleToast("Note Pinned Successfully")
                } else
                    if (response.data.note.isPinned == false) {
                        showHandleToast("Note Unpinned Successfully")
                    }
                getAllNotes();
            }

        } catch (error) {
            console.log(error)
        }

    }

    //Clear Search
    const handleClearSerch = () => {
        setIsSearch(false);
        getAllNotes();
    }
    const handleNoteClick = (note) => {
        setSelectedNote(note);
    };
    const handleCloseFullCard = () => {
        setSelectedNote(null);
    };


    useEffect(() => {
        getAllNotes();
        getUserInfo();
        return () => { }
    }, [])

    return (
        <>
            <Navbar userInfo={userInfo} onSearchNote={onSearchNote} handleClearSerch={handleClearSerch} />
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                {allNotes.length > 0 ?
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mt-8">
                        {allNotes.map((note, index) => (
                            <NoteCard key={note._id}
                                title={note.title}
                                date={note.createdOn}
                                content={note.content}
                                tags={note.tags}
                                isPinned={note.isPinned}
                                onNoteClick={() => handleNoteClick(note)}
                                onEdit={() => handleEdit(note)}
                                onDelete={() => DeleteNote(note)}
                                onPinNote={() => updatePinedNote(note)}
                            />

                        ))}
                    </div> :
                    <EmptyCard
                        message={
                            isSearch ? `Oops No Items Found` : `Start Adding Your Notes Today! Create Your First Note by Clicking the Add Icon`}
                        imgSrc={isSearch ? NoData : AddItemsSvg} />
                }
                {selectedNote && (
                    <FullCard note={selectedNote} onClose={handleCloseFullCard} />
                )}
                <button
                    className="h-16 w-16 flex items-center justify-center rounded-2xl bg-blue-500 hover:bg-blue-600 fixed right-10 bottom-10"
                    onClick={() => { setOpenAddEditModal({ isShown: true, type: 'add', data: null }) }}
                >
                    <MdAdd className="text-[32px] text-white" />
                </button>
            </div>
            <Modal
                isOpen={OpenAddEditModal.isShown}
                onRequestClose={() => { }}
                contentLabel=""
                className={`drop-shadow h-auto bg-white rounded-xl mx-auto mt-14 p-5 w-[90%] sm:w-[75%] md:w-[60%] lg:w-[40%]`}
            >
                <AddEditNotes
                    data={OpenAddEditModal.data}
                    type={OpenAddEditModal.type}
                    getAllNotes={getAllNotes}
                    onClose={() => setOpenAddEditModal({
                        isShown: false,
                        type: 'add',
                        data: null
                    })}
                    showHandleToast={showHandleToast}
                />
            </Modal>

            <Toast
                isShown={showToast.isShown}
                type={showToast.type}
                message={showToast.message}
                onClose={handleToastClose}

            />
        </>

    )
}

export default Home
